<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('company.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('company.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <!-- <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div> -->
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.company_name_kh }}</td>
          <td>{{ record.company_name_en }}</td>
          <td>{{ record.company_phone }}</td>
          <td>{{ $store.getters.limitStringShow(record.company_address) }}</td>
          <td>{{ record.company_website }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <!-- <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin ml-2" v-if="record._deleting"></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </a-popconfirm> -->
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('company.pageTitle')"
        centered
        @ok="() => (showForm = false)"
        :zIndex="1020"
        :footer="null"
      >
        <from-action
          @cancel="() => (showForm = false)"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'companyIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/company', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.company.search
      },
      set(newValue) {
        this.$store.commit('administrator/company/SET_SEARCH', newValue)
        this.$store.commit('administrator/company/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('company.companyNameKH') },
        { name: this.$t('company.companyNameEN') },
        { name: this.$t('company.phone') },
        { name: this.$t('company.address') },
        { name: this.$t('company.website') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/company/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('administrator/company/SET_EDIT_DATA', record)
      this.showForm = true
    }
  },
  watch: {
    // search: debounce(function(search) {
    //   this.fetchData({ search })
    // }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/company/RESET_STATE')
    next()
  }
}
</script>
